// @ts-nocheck
/* eslint-disable */
export const sortArrowIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M3.5 6.5h9a.5.5 0 0 0 .353-.853l-4.5-4.5a.5.5 0 0 0-.707 0l-4.5 4.5A.5.5 0 0 0 3.5 6.5m9 3h-9a.5.5 0 0 0-.354.854l4.5 4.5a.5.5 0 0 0 .707 0l4.5-4.5A.5.5 0 0 0 12.5 9.5"/></svg>`,
    name: 'sort-arrow' as const
};